import { render, staticRenderFns } from "./AreaNotesModal.vue?vue&type=template&id=4f8ca668&scoped=true"
import script from "./AreaNotesModal.vue?vue&type=script&lang=ts"
export * from "./AreaNotesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ca668",
  null
  
)

export default component.exports